export { default } from './dialog.provider';
export * from './dialog-provider-props.interface';
